import React, { useEffect, useState } from 'react';
import { MapPin } from '@phosphor-icons/react';
import LocationPickerModal from '../common/LocationPickerModal.jsx';

const hasCoordinates = (coordinates) => (
  coordinates?.lat !== null
  && coordinates?.lat !== undefined
  && coordinates?.lat !== ''
  && coordinates?.lng !== null
  && coordinates?.lng !== undefined
  && coordinates?.lng !== ''
);

const formatCoordinates = (coordinates) => (
  typeof coordinates?.rawValue === 'string'
    ? coordinates.rawValue
    : hasCoordinates(coordinates)
      ? `${coordinates.lat}, ${coordinates.lng}`
      : ''
);

const parseCoordinates = (value, normalizeCoordinates) => {
  const parts = value.split(',').map((part) => part.trim());
  if (parts.length !== 2 || !parts[0] || !parts[1]) return null;

  const lat = Number(parts[0]);
  const lng = Number(parts[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return normalizeCoordinates(lat, lng);
};

function CoordinatesPickerField({
  value,
  onChange,
  onBlur,
  disabled = false,
  normalizeCoordinates,
  placeholder = 'Ej: -31.5375, -68.5364',
  markerId = 'selected-location'
}) {
  const safeValue = value || { lat: null, lng: null };
  const [inputValue, setInputValue] = useState(() => formatCoordinates(safeValue));
  const [mapOpen, setMapOpen] = useState(false);
  const [mapCoordinates, setMapCoordinates] = useState({ lat: '', lng: '' });

  useEffect(() => {
    setInputValue(formatCoordinates(safeValue));
  }, [safeValue.lat, safeValue.lng, safeValue.rawValue]);

  const handleInputChange = (event) => {
    const nextInputValue = event.target.value;
    const parsedCoordinates = parseCoordinates(nextInputValue, normalizeCoordinates);

    setInputValue(nextInputValue);
    onChange(parsedCoordinates
      ? { ...parsedCoordinates, rawValue: nextInputValue }
      : { lat: null, lng: null, rawValue: nextInputValue });
  };

  const openMap = () => {
    setMapCoordinates(hasCoordinates(safeValue) ? safeValue : { lat: '', lng: '' });
    setMapOpen(true);
  };

  return (
    <>
      <div className="flex items-start gap-4">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className="h-12 min-w-0 flex-1 rounded-md border border-line bg-surface-2 px-3 py-2 text-sm text-content placeholder-content-muted focus:outline-none focus:ring-2 focus:ring-amber disabled:cursor-not-allowed disabled:opacity-60"
        />
        <button
          type="button"
          onClick={openMap}
          disabled={disabled}
          title="Seleccionar coordenadas en el mapa"
          className="flex h-12 shrink-0 items-center justify-center rounded-md bg-amber px-4 py-2 text-on-amber transition-colors hover:bg-amber-hover disabled:cursor-not-allowed disabled:opacity-60"
        >
          <MapPin size={16} />
        </button>
      </div>

      <LocationPickerModal
        open={mapOpen}
        coordinates={mapCoordinates}
        onCoordinatesChange={setMapCoordinates}
        onClose={() => setMapOpen(false)}
        onConfirm={(coordinates) => {
          const formattedCoordinates = `${coordinates.lat}, ${coordinates.lng}`;
          onChange({ ...coordinates, rawValue: formattedCoordinates });
          setInputValue(formattedCoordinates);
          setMapOpen(false);
        }}
        normalizeCoordinates={normalizeCoordinates}
        markerId={markerId}
        minZoom={13}
        maxBounds={[[-90, -180], [90, 180]]}
      />
    </>
  );
}

export default CoordinatesPickerField;
